import React, { Fragment } from 'react';
import axios from 'axios';
import { FILE_BASE_URL, SUPPORTED_FILE_TYPES_FOR_PREVIEW } from '../constants/AppConstants';
import { getFileMimeType } from '../helpers/DataHelpers';
import { handleDownloadClick } from '../helpers/PdfViewerHelpers';

const DOWNLOAD_WARNING = 'While this file is encrypted during transmission, once downloaded, you are responsible for implementing appropriate safeguards to protect the data, including encryption or deletion to the extent required by applicable law.'; // eslint-disable-line max-len

export default function LinkedAttachments(props) {
  const { event, breakBeforeFirstAttachment, isNativeAndroid } = props;

  const buildAttachmentWithDownloadLink = (attachment) => {
    const { attachmentUrl } = attachment;
    const downloadURL = `${FILE_BASE_URL}${attachmentUrl}`;
    const fileType = attachment.type || getFileMimeType(downloadURL);
    const filename = attachment.name;
    return { downloadURL, fileType, filename };
  };

  const filterPreviewableAttachments = (attachment) => !SUPPORTED_FILE_TYPES_FOR_PREVIEW.includes(attachment.fileType);

  const handleAttachmentDownload = async (e, attachment) => {
    e.preventDefault();
    // eslint-disable-next-line no-alert
    if (!window.confirm(DOWNLOAD_WARNING)) return;
    // Native WebView (Android & iOS) cannot resolve blob URLs — use the HTTP URL directly
    if (isNativeAndroid || window.ReactNativeWebView) {
      handleDownloadClick(attachment.downloadURL, attachment.filename, isNativeAndroid, true);
      return;
    }
    try {
      const { data } = await axios.get(attachment.downloadURL, { responseType: 'blob' });
      const blobUrl = URL.createObjectURL(data);
      handleDownloadClick(blobUrl, attachment.filename, isNativeAndroid, true);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch {
      handleDownloadClick(attachment.downloadURL, attachment.filename, isNativeAndroid, true);
    }
  };

  const nonPreviewableAttachments = event?.attachments
    ?.map(buildAttachmentWithDownloadLink)
    .filter(filterPreviewableAttachments);
  if (!nonPreviewableAttachments?.length) return null;
  return (
    <>
      { nonPreviewableAttachments?.map((attachment, index) => (
        <Fragment key={attachment.downloadURL}>
          {!(!breakBeforeFirstAttachment && index === 0) && (<br />)}
          <a
            href={attachment.downloadURL}
            onClick={(e) => handleAttachmentDownload(e, attachment)}
          >
            {attachment.filename}
          </a>
        </Fragment>
      ))}
    </>
  );
}
